import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { GRAPH_CMS_TOKEN } from './tokens';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly authToken = inject(GRAPH_CMS_TOKEN, { optional: true });

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const setHeaders: Record<string, string> = {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json'
    };

    if (this.authToken) {
      setHeaders['Authorization'] = this.authToken.startsWith('Bearer ')
        ? this.authToken
        : `Bearer ${this.authToken}`;
    }

    return next.handle(req.clone({ setHeaders })).pipe(
      catchError((err) => {
        // eslint-disable-next-line no-console
        console.error('GraphCMS request error', err);
        return throwError(() => err);
      })
    );
  }
}
